import gql from 'graphql-tag';

export class AttachmentQueries {
  static getUploadLink = gql`
    query getUploadLink($attachmentId: String!, $fileExtension: AttachmentExtension!) {
      uploadAttachmentLink(attachmentId: $attachmentId, fileExtension: $fileExtension) {
        url
        headers
      }
    }
  `;
}
